// src/rms/ads/AdMasthead.js
// ============================================================================
// Two equal banners across the top of the content area
// ============================================================================
// Two 468x60 IAB full banners rather than one 728x90 leaderboard, so the header
// carries two advertisers instead of one. They are laid out as equal columns
// and stay equal even when only one fills -- an unfilled slot leaves its space
// rather than letting its neighbour stretch, because a banner that changes
// width between page loads reads as broken.
//
// Deliberately NOT sticky: the topbar pins, this scrolls away, so it can never
// occlude the working area.
// ============================================================================

import React from "react";
import AdUnit from "./AdUnit";

function AdMasthead({ selections = [] }) {
  if (!selections.some(Boolean)) return null;

  return (
    <div className="rms-masthead">
      {selections.map((selection, i) => (
        <div className="rms-masthead-unit" key={selection?.slotKey || `empty-${i}`}>
          {selection ? (
            <AdUnit
              slot={selection.slot}
              slotKey={selection.slotKey}
              campaign={selection.campaign}
              variant="banner"
            />
          ) : null}
        </div>
      ))}
    </div>
  );
}

export default AdMasthead;
